import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Container, Row } from 'react-bootstrap';
import Button from '../../../components/Button';
import useModal from '../../../hooks/useModal';

import { DateFormats, formatDate } from '../../../utils/utils';
import SummaryModal from './summaryModal';

const Successful = () => {
  const [showSummaryModal, handleShowSummaryModal, handleCloseSummaryModal] =
    useModal();
  const date = new Date();

  return (
    <Container
      className={'mb-12 mt-12 px-0 px-xl-0 border-light-gray rounded-1'}
    >
      <Row className="d-flex flex-column p-11">
        <Col className="d-flex justify-content-center">
          <h5 className="m-0">Successful</h5>
        </Col>
        <Col className="d-flex justify-content-center mt-7">
          <span className="text-sub1 fw-light lh-xs">
            Your beneficiary has been verified
          </span>
        </Col>
        <Col className="d-flex justify-content-center mt-7">
          <img
            src={`${process.env.PUBLIC_URL}/${'successful.png'}`}
            alt="successful"
          />
        </Col>
        <Col className="d-flex flex-column justify-content-between flex-sm-row mt-11">
          <Col className="d-flex justify-content-between align-items-center col-12 col-sm-6">
            <Row className="d-flex flex-column r">
              <span className="text-sub1 fw-normal lh-xs">Submitted</span>
              <span className="text-sub1 fw-light lh-xs">
                {formatDate(
                  new Date(date.getFullYear(), date.getMonth(), date.getDay()),
                  DateFormats.MONTH_DAY_YEAR
                )}
              </span>
            </Row>
            <Row className="d-flex flex-column align-items-center ">
              <Col className="ps-12 text-sub1 fw-normal lh-xs">Status</Col>
              <Col>
                <span className="fill-marks--green me-5">
                  <FontAwesomeIcon icon={light('check')} />
                </span>
                <span className="text-sub1 fw-light lh-xs"> Completed</span>
              </Col>
            </Row>
          </Col>

          <Col className="d-flex flex-column align-items-stretch  align-items-sm-end mt-11 mt-lg-0">
            <Button
              variant="primary-outline"
              className={'mx-lg-10 order-1 order-lg-3'}
              size="sm"
            >
              Download/Print
            </Button>
            <Button
              variant="primary"
              className={'mx-lg-10 order-1 order-lg-3 mt-3'}
              size="sm"
              onClick={handleShowSummaryModal}
            >
              Show Summary
            </Button>
            <SummaryModal
              show={showSummaryModal}
              handleClose={handleCloseSummaryModal}
            />
          </Col>
        </Col>
      </Row>
    </Container>
  );
};

export default Successful;
